module.exports = __webpack_public_path__ + "img/comparison.5485aa1f.svg";